export const SCRIPT_BATCH_FETCH_SIZE = 3; // geojson is particularly slow to parse

export const DEFAULT_ID = '_default_';

export const resourceType = {
  ADVANCED_SCRIPT_AVAILABILITY: 'advanced_script_availability',
  ADVANCED_SCRIPT_RECOMMENDATIONS: 'advanced_script_recommendations',
  AFFILIATE_LIST: 'affiliate_list',
  CROP_LIST: 'crop_list',
  DEVICE_LIST: 'device_list',
  EXPERIMENTS: 'experiments',
  FARMS: 'farms',
  FERTILITY_CHEMICAL_STABILIZERS: 'fertility_chemical_stabilizers',
  FERTILITY_CHEMICAL_SUBSTANCES: 'fertility_chemical_substances',
  FERTILITY_CHEMICAL_TYPES: 'fertility_chemical_types',
  FIELDS: 'fields',
  FIELD_SEASONS: 'field_seasons',
  FIELDS_BY_OPERATION_ID: 'fields_by_operation_id',
  COMPLETE_MAP_LAYERS: 'complete_map_layers',
  LAYERS_FOR_ZONE_GENERATION: 'layers_for_zone_generation',
  MANAGEMENT_ZONES: 'management_zones',
  MAP_ZONES: 'map_zones',
  OPERATIONS: 'operations',
  PREFERRED_DEVICE: 'preferred_device',
  PRIMARY_SCRIPT_LIST: 'primary_script_list',
  RAW_SCRIPTS_LIST: 'raw_scripts_list',
  RAW_SCRIPTS_BY_FIELD_UUID: 'raw_scripts_by_field_uuid',
  SCOUTING_IMAGERY: 'scouting_imagery',
  SCRIPT_LIST: 'script_list',
  SELECT_FIELD_MAP_LAYER: 'select_field_map_layer',
  DRIVE_DEVICES: 'drive_devices',
  JOHN_DEERE_FIELDS: 'john_deere_fields',
  JOHN_DEERE_WORK_PLANS: 'john_deere_work_plans'
};

export const resourceStatus = {
  // Note: you shouldn't be using these directly, use selectors
  PENDING: 'pending',
  LOADED: 'loaded',
  UNLOADED: 'unloaded'
};

export const resourceError = {
  EMPTY: 'empty',
  CONFLICT: 'conflict'
};
